import { Button, DatePicker, Input, Progress, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import {
  DownloadOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { render } from "@testing-library/react";
import moment from "moment";
import { useSelector } from "react-redux";
import EmailReportDrawer from "../../component/emailReportDrawer/EmailReportDrawer";
import { filter } from "lodash";
const EmailReport = () => {
  const [loading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState("");
  const [exportingData, setExportingData] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [userAccounts, setUserAccounts] = useState([]);
  const [openFilters, setOpenFilters] = useState(false);
  const [summarData, setSummryData] = useState({});
  const [accStatsData, setAccStatsData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [emailSearch,setEmailSearch] = useState("")
  const [emailReport,setEmailReport] = useState([])
  const [fromDate, setFromDate] = useState(() => {
    return dayjs().startOf("month").format("MM-DD-YYYY");
  });
  const [accPagination, setAccPagination] = useState(10);
  const [allemails,setAllEmails]= useState([]);
  const [selectedEmail,setSelectedEmail] = useState(null)
  const [emailPagination,setEmailPagination] = useState(10)

  const [toDate, setToDate] = useState(() =>
    dayjs().endOf("day").format("MM-DD-YYYY"),
  );
  const SelectedPharmacy = useSelector((state) => {
    return state.pharmacyData?.pharmacyData;
  });
  const userInfo = useSelector((state) => state.userAuth.decodedToken.user);
  const [allUserFetched, setAllUserFetched] = useState(false);

  const getDisplayPharmacy = (account) => {
    const isGoodUser = userInfo?.user_roles_id === 5;

    if (isGoodUser && account?.acct_id === 96167) {
      return {
        ...account,
        displayName: "ABC Pharmacy",
        displayId: "123456",
      };
    }
    return {
      ...account,
      displayId: account.acct_id,
      displayName: account.name || account.label,
    };
  };
  const getData = async (filters) => {
    if (!currentPage || !pageSize || !fromDate || !toDate) {
      return;
    }
    const paramas = {
      page: currentPage,
      limit: pageSize,
      startDate: fromDate,
      endDate: toDate,
      recipientEmail : selectedEmail,
      ...(filters?.status && {
        status: filters.status,
      }),

      ...(filters?.engagementStatus && {
        engagementStatus: filters.engagementStatus,
      }),

      ...(filters?.Subject && {
        subject: filters.Subject,
      }),

      ...(filters?.emailType && {
        emailType: filters.emailType,
      }),

      ...(filters?.accountId && {
        accountId: Number(filters.accountId),
      }),
    };
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `api/notifications/report/email-delivery`,
        {
          params: paramas,
        },
      );
      setSummryData(response?.data?.summary);
      setData(response?.data?.rows);
      setAccStatsData(response?.data?.account_stats);
      setTotalRecords(response?.data?.pagination?.totalRecords);
      setCurrentPage(response?.data?.pagination?.page);
      setPageSize(response?.data?.pagination?.limit);
      setAllEmails(response?.data?.email_options);
      setEmailReport(response?.data?.email_breakdown);
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setIsLoading(false);
    }
  };
  function formatDate(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const RateProgress = ({ value = 0, color }) => (
    <div className="flex items-center gap-3">
      <Progress
        percent={value}
        showInfo={false}
        strokeColor={color}
        trailColor="#E5E7EB"
        strokeWidth={8}
        style={{ width: 120, marginBottom: 0 }}
      />
      <span className="text-gray-600 font-medium">{value.toFixed(2)}%</span>
    </div>
  );

  const getApiVersionByDate = (date) => {
    if (!date) return "v2";
    const sep2025 = new Date("2025-09-01");
    const selectedDate = new Date(date);

    return selectedDate < sep2025 ? "" : "api/v2/";
  };
  const updatePharmacies = (value) => {
    setSelectedAccounts(value);
  };

  const acctColumns = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return String(record?.account_id)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Sent",
      dataIndex: "total_sent",
      key: "total_sent",
      render: (val) => val ?? "-",
      sorter: false,
      align: "right",
    },
    {
      title: "Delivered",
      dataIndex: "delivered",
      key: "delivered",
      render: (val) => val ?? "-",
      sorter: false,
      align: "right",
    },
    {
      title: "opened",
      dataIndex: "opened",
      key: "opened",
      render: (v) => (v ? v : "-"),
      sorter: false,
      align: "Right",
    },
    {
      title: "Clicked",
      dataIndex: "clicked",
      key: "clicked",
      render: (v) => (v ? v : "-"),
      sorter: false,
      align: "Right",
    },
    {
      title: "Delivery Rate",
      dataIndex: ["rates", "delivery_rate"],
      key: "delivery_rate",
      render: (value) => (
        <RateProgress value={Number(value || 0)} color="#22C55E" />
      ),
    },
    {
      title: "Open Rate",
      dataIndex: ["rates", "open_rate"],
      key: "open_rate",
      render: (value) => (
        <RateProgress value={Number(value || 0)} color="#3B82F6" />
      ),
    },
    {
      title: "Click-through Rate",
      dataIndex: ["rates", "click_through_rate"],
      key: "click_through_rate",
      render: (value) => (
        <RateProgress value={Number(value || 0)} color="#F59E0B" />
      ),
    },
  ];

  const emailColumns = [
    {
      title: "Email",
      dataIndex: "recipient_email",
      key: "recipient_email",
      filteredValue: [emailSearch],
      onFilter: (value, record) => {
        return String(record?.recipient_email)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Sent",
      dataIndex: "total_sent",
      key: "total_sent",
      render: (val) => val ?? "-",
      sorter: false,
      align: "right",
    },
    {
      title: "Delivered",
      dataIndex: "delivered",
      key: "delivered",
      render: (val) => val ?? "-",
      sorter: false,
      align: "right",
    },
    {
      title: "opened",
      dataIndex: "opened",
      key: "opened",
      render: (v) => (v ? v : "-"),
      sorter: false,
      align: "Right",
    },
    {
      title: "Clicked",
      dataIndex: "clicked",
      key: "clicked",
      render: (v) => (v ? v : "-"),
      sorter: false,
      align: "Right",
    },
    {
      title: "Delivery Rate",
      dataIndex: ["rates", "delivery_rate"],
      key: "delivery_rate",
      render: (value) => (
        <RateProgress value={Number(value || 0)} color="#22C55E" />
      ),
    },
    {
      title: "Open Rate",
      dataIndex: ["rates", "open_rate"],
      key: "open_rate",
      render: (value) => (
        <RateProgress value={Number(value || 0)} color="#3B82F6" />
      ),
    },
    {
      title: "Click-through Rate",
      dataIndex: ["rates", "click_through_rate"],
      key: "click_through_rate",
      render: (value) => (
        <RateProgress value={Number(value || 0)} color="#F59E0B" />
      ),
    },
  ];

  const columns = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      sorter: false,
    },
    {
      title: "Email Type",
      dataIndex: "email_type",
      key: "email_type",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
    },
    {
      title: "Engagement Status",
      dataIndex: "engagement_status",
      key: "engagement_status",
      render: (v) => (v ? v : "-"),
      sorter: false,
    },
    {
      title: "Recipient Email",
      dataIndex: "recipient_email",
      key: "recipient_email",
      render: (v) => (v ? v : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "left",
      sorter: true,
    },
    //  {
    //   title: "Price",
    //   dataIndex: "price",
    //   key: "price",
    //   render: (price) => `-`,
    //   // sorter: (a, b) => a.unit_price - b.unit_price,
    // },
    {
      title: "Created At",
      key: "created_at",
      dataIndex: "created_at",
      align: "left",
      render: (val) => (val ? moment(val)?.format("MM-DD-YYYY") : "-"),
    },
    {
      title: "Sent At",
      dataIndex: "sent_at",
      key: "sent_at",
      render: (val) => (val ? moment(val)?.format("MM-DD-YYYY") : "-"),
    },
    {
      title: "Delivered At",
      key: "delivered_at",
      dataIndex: "delivered_at",
      render: (val) => (val ? moment(val)?.format("MM-DD-YYYY") : "-"),
    },
  ];

  const handleExport = async () => {
    try {
      setExportingData(true);
      const response = await axiosInstance.get(
        "api/notifications/report/email-delivery",
      );
      const exportData = response?.data?.rows;
      const headers = [
        "Account ID",
        "Subject",
        "Email Type",
        "Engagement Status",
        "Recipient Email",
        "Status",
        "Created At",
        "Sent At",
        "Delivered At",
      ];

      const rows = exportData?.map((item) => [
        item?.account_id,
        item?.subject,
        item?.email_type,
        item?.engagement_status,
        item?.recipient_email,
        item?.status,
        item?.created_at,
        item?.sent_at,
        item?.delivered_at,
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Email Report");
      XLSX.writeFile(workbook, "EmailReport.xlsx");
    } catch (error) {
      console.log(error);
    } finally {
      setExportingData(false);
    }
  };

  // const fetchUserAccounts = async () => {
  //   const formattedFromDate = formatDate(fromDate);
  //   const apiVersion = getApiVersionByDate(formattedFromDate);
  //   try {
  //     const response = await axiosInstance.get(
  //       `/${apiVersion}users/accounts?email=${userInfo?.email}`,
  //     );
  //     setUserAccounts(response.data.data.data);
  //     setAllUserFetched(true);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (!allUserFetched) return; // wait for fetch
  //   if (userAccounts.length > 0 && selectedAccounts?.length === 0) {
  //     const specialUser = userAccounts.find((user) => user.acct_id === 96167);
  //     if (SelectedPharmacy) {
  //       setSelectedAccounts(SelectedPharmacy);
  //     } else if (specialUser) {
  //       setSelectedAccounts([specialUser?.acct_id]);
  //     } else {
  //       setSelectedAccounts([userAccounts[0]?.acct_id]);
  //     }
  //   }
  // }, [userAccounts, selectedAccounts, allUserFetched]);

  useEffect(() => {
    getData();
  }, [currentPage, pageSize, fromDate, toDate,selectedEmail]);

  // useEffect(() => {
  //   fetchUserAccounts();
  // }, []);
  return (
    <>
      <HeaderCompo initialColor={"#000833"} />
      <div className="p-6" style={{ padding: "16px 16px 0 16px" }}>
        <div className="my-5 flex justify-between items-start flex-col md:flex-row">
          <h1 className="text-2xl font-bold">Email Delivery Report</h1>
          <div className="p-3 w-full md:w-[400px]">
      <Select
        // mode="tags"
        allowClear
        placeholder="Filter By Email"
        className="w-full"
        value={selectedEmail}
        onChange={(values) => {
          setSelectedEmail(values);
        }}
        options={allemails?.map((email) => ({
          label: email,
          value: email,
        }))}
      />
    </div>
        </div>
        <div className=" p-6 rounded-lg">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 ">
          <div className="bg-[#DCF3FF] rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-all duration-200 p-5">
            <p className="text-sm font-medium text-gray-500">Total Sent</p>

            <h2 className="text-3xl text-gray-900 mt-2 font-jetbrains smallCarddata">
              {summarData?.total_sent ?? "-"}
            </h2>
          </div>
          <div className="bg-[#DCF3FF] rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-all duration-200 p-5">
            <p className="text-sm font-medium text-gray-500">Delivered</p>

            <h2 className="text-3xl text-gray-900 mt-2 font-jetbrains smallCarddata">
              {summarData?.delivered ?? "-"}
            </h2>
            <p className="text-xs text-gray-700 mt-3 min-h-[18px]">
              {summarData?.rates?.delivery_rate
                ? `${summarData?.rates?.delivery_rate?.toFixed(2)}% delivery rate`
                : "0% delivery rate"}
            </p>
          </div>
          <div className="bg-[#DCF3FF] rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-all duration-200 p-5">
            <p className="text-sm font-medium text-gray-500">Opened</p>

            <h2 className="text-3xl text-gray-900 mt-2 font-jetbrains smallCarddata">
              {summarData?.opened}
            </h2>
            <p className="text-xs text-gray-700 mt-3 min-h-[18px]">
              {summarData?.rates?.open_rate
                ? `${summarData?.rates?.open_rate?.toFixed(2)}% open rate`
                : "0% open rate"}{" "}
            </p>
          </div>
          <div className="bg-[#DCF3FF] rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-all duration-200 p-5">
            <p className="text-sm font-medium text-gray-500">Clicked</p>

            <h2 className="text-3xl font-jetbrains smallCarddata text-gray-900 mt-2">
              {summarData?.clicked}
            </h2>
            <p className="text-xs text-gray-700 mt-3 min-h-[18px]">
              {summarData?.rates?.click_through_rate
                ? `${summarData?.rates?.click_through_rate?.toFixed(2)}% of opens`
                : "0% of opens"}{" "}
            </p>
          </div>
          <div className="bg-[#DCF3FF] rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-all duration-200 p-5">
            <p className="text-sm font-medium text-gray-500">Bounced</p>

            <h2 className="text-3xl font-jetbrains smallCarddata text-gray-900 mt-2">
              {summarData?.bounced}
            </h2>
            <p className="text-xs text-gray-700 mt-3 min-h-[18px]">
              {summarData?.rates?.bounce_rate
                ? `${summarData?.rates?.bounce_rate?.toFixed(2)}% bounce rate`
                : "0% bounce rate"}
            </p>
          </div>
          <div className="bg-[#DCF3FF] rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-all duration-200 p-5">
            <p className="text-sm font-medium text-gray-500">Unsubscribed</p>

            <h2 className="text-3xl font-jetbrains smallCarddata text-gray-900 mt-2">
              {summarData?.unsubscribed ?? "-"}
            </h2>
            <p className="text-xs text-gray-700 mt-3 min-h-[18px]">
              {summarData?.rates?.unsubscribe_rate
                ? `${summarData?.rates?.unsubscribe_rate?.toFixed(2)}% rate`
                : "0% rate"}
            </p>
          </div>
        </div>
        </div>
        <div className="mt-10 flex justify-between items-start">
          <h1 className="text-2xl font-bold">Email Report Breakdown</h1>
        </div>
        <div className="w-full flex justify-end">
          <Input
            placeholder="Search By Mail"
            prefix={<SearchOutlined />}
            className="w-full md:max-w-[300px] border-x-2 border-gray-300"
            onChange={(e) => setEmailSearch(e.target.value)}
            style={{ border: "1px solid var(--Primary-Dark-gray, #777)" }}
          />
        </div>
        <Table
          dataSource={emailReport}
          rowKey=""
          scroll={{ x: "max-content" }}
          columns={emailColumns}
          loading={loading}
          className="custom-table user-tbl"
          pagination={{
            pageSize: emailPagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} Records`,
            onShowSizeChange: (current, size) => {
              setEmailPagination(size);
            },
          }}/>
        <div className="mt-10 flex justify-between items-start">
          <h1 className="text-2xl font-bold">Pharmacy Account Breakdown</h1>
        </div>
        <div className="w-full flex justify-end">
          <Input
            placeholder="Filter By Accont ID"
            prefix={<SearchOutlined />}
            className="w-full md:max-w-[300px] border-x-2 border-gray-300"
            onChange={(e) => setSearchText(e.target.value)}
            style={{ border: "1px solid var(--Primary-Dark-gray, #777)" }}
          />
        </div>
        <Table
          dataSource={accStatsData}
          rowKey=""
          scroll={{ x: "max-content" }}
          columns={acctColumns}
          loading={loading}
          className="custom-table user-tbl"
          pagination={{
            pageSize: accPagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} Records`,
            onShowSizeChange: (current, size) => {
              setAccPagination(size);
            },
          }}
          // pagination={{
          //   current: currentPage,
          //   total: totalRecords,
          //   pageSize: pageSize,
          //   showSizeChanger: true,
          //   showTotal: (total, range) =>
          //     `${range[0]}-${range[1]} of ${total} items`,
          // }}
          // onChange={(pagination, filters, sorter) => {
          //   if (sorter?.field === "unit_price") {
          //     setCurrentPage(1);
          //     // setSortOrder(sorter?.order === "descend" ? "desc" : "asc");
          //   } else {
          //     setCurrentPage(pagination?.current);
          //     setPageSize(pagination?.pageSize);
          //   }
          // }}
        />

        <div className="flex flex-col lg:flex-row gap-4 lg:items-center lg: justify-end w-full">
          <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3 w-full lg:w-auto">
            <div className="flex flex-col xs:flex-row gap-3 w-full sm:w-auto">
              <div className="flex items-center gap-2 w-full sm:w-auto">
                <span className="font-medium text-gray-600 whitespace-nowrap">
                  From
                </span>
                <DatePicker
                  value={fromDate ? dayjs(fromDate) : null}
                  format="MM-DD-YYYY"
                  className="w-full sm:w-[250px]"
                  placeholder="Select Start Date"
                  onChange={(date) => {
                    if (date) {
                      const formattedDate = date.format("MM-DD-YYYY");
                      setFromDate(formattedDate);
                    }
                  }}
                />
              </div>

              <div className="flex items-center gap-2 w-full sm:w-auto">
                <span className="font-medium text-gray-600 whitespace-nowrap">
                  To
                </span>
                <DatePicker
                  value={toDate ? dayjs(toDate) : null}
                  format="MM-DD-YYYY"
                  className="w-full sm:w-[250px]"
                  placeholder="Select End Date"
                  onChange={(date) => {
                    if (date) {
                      const formattedDate = date.format("MM-DD-YYYY");
                      setToDate(formattedDate);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex gap-2 items-start">
            <div className="w-full lg:w-auto flex lg:justify-end">
              <Button
                className="w-full lg:w-auto"
                icon={<DownloadOutlined />}
                loading={exportingData}
                onClick={handleExport}
              >
                Export
              </Button>
            </div>
            <div className="w-full lg:w-auto flex lg:justify-end">
              <Button
                type="primary"
                className="w-full lg:w-auto"
                icon={<FilterOutlined />}
                onClick={() => setOpenFilters(true)}
              >
                Filters
              </Button>
            </div>
          </div>
        </div>
        <Table
          dataSource={data}
          rowKey=""
          scroll={{ x: "max-content" }}
          columns={columns}
          loading={loading}
          className="custom-table user-tbl"
          pagination={{
            current: currentPage,
            total: totalRecords,
            pageSize: pageSize,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          onChange={(pagination, filters, sorter) => {
            if (sorter?.field === "unit_price") {
              setCurrentPage(1);
              // setSortOrder(sorter?.order === "descend" ? "desc" : "asc");
            } else {
              setCurrentPage(pagination?.current);
              setPageSize(pagination?.pageSize);
            }
          }}
        />
      </div>
      <EmailReportDrawer
        visible={openFilters}
        onClose={() => setOpenFilters(false)}
        getEmailReports={getData}
      />
    </>
  );
};

export default EmailReport;
